import "./animation.css";

function AnimationPage({ message = "Nalagam..." }) {
	return (
		<div className="bg">
			<div className="animation" id="animation">
				<div className="box">
					<div class="profile-main-loader">
						<div class="loader">
							<svg class="circular-loader" viewBox="25 25 50 50">
								<circle
									class="loader-path"
									cx="50"
									cy="50"
									r="20"
									fill="none"
									stroke-width="3"
								/>
							</svg>
						</div>
					</div>
					<a className="text" href="#message">
						<span className="message"></span>
						{message}
					</a>
				</div>
			</div>
		</div>
	);
}

export default AnimationPage;
